import { effect, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  private status = signal<undefined | 'loading' | 'loaded' | 'error'>(undefined);

  ready = signal<boolean>(false);

  constructor() {
    effect(() => {
      if (this.status() === 'loading') {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.key}&libraries=places,marker`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
          this.status.set('loaded');
          this.ready.set(true);
        };

        script.onerror = () => {
          this.status.set('error');
          console.error('Google Maps failed to load');
        };

        document.head.appendChild(script);
      }
    });
  }

  load(): void {
    if (this.status() === undefined) {
      this.status.set('loading');
    }
  }
}
